import { ProfileDto, WorkspaceDto } from '@plot/plot-api';

import {
  BaseBoundData,
  BaseEvent,
  BaseTracker,
} from '@/lib/analytics/trackers/BaseTracker';

export declare interface WorkspaceTrackerBoundData extends BaseBoundData {
  user: ProfileDto;
  workspace: WorkspaceDto;
}

export class WorkspaceTracker<
  BoundData extends WorkspaceTrackerBoundData = WorkspaceTrackerBoundData
> extends BaseTracker<BoundData> {
  /*
   Every action of logged-in user takes place inside workspace, so in fact this is the base tracker class.
   */
  track(eventName: string, eventAttributes: BaseEvent) {
    super.track(eventName, {
      workspaceId: this.boundData.workspace.id,
      ...eventAttributes,
    });
  }

  workspaceSelected(workspaceId: string) {
    /*
     Selected new workspaceId that override one stored in boundData
     */
    this.track('WorkspaceSelected', {
      workspaceId,
      trackingEventTrancheNumber: 0,
    });
  }
}
